import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createUser } from "api";
import { Button } from "components";
import { useHistory } from "react-router-dom";
import "./userAction.scss";
import {
  setUsersTablePage,
} from "store/actions";
import { initialState, prepareData } from "../Components/UserHelper";
import UserForm from "../Components/UserForm";

const UserEdit = () => {
  const history = useHistory();
  const [formData, setFormData] = useState(initialState(prepareData([])));
  const [errorBorders, setErrorBorders] = useState([]);
  const [image, setImage] = useState("");
  const dispatch=useDispatch()

  const handleSubmit = (e) => {
    e.preventDefault();

    const multiFormData = new FormData();
    Object.entries(formData).forEach((arr) =>
      arr[1].forEach((obj) => multiFormData.append(obj.name, obj.value))
    );

    createUser(multiFormData)
      .then((res) => {
        if (res.status === 201) {
          setErrorBorders([]);
          setFormData(initialState);
        }
        dispatch(setUsersTablePage(1))
        history.goBack();
      })
      .catch((err) => {
        console.error(err.response.data);
        const { errors } = err.response.data;
        let newErrors = [];
        Object.keys(errors).forEach((key) => {
          newErrors.push(key);
        });
        setErrorBorders([...newErrors]);
      })
      .finally(() => {});
  };

  return (
    <div className="create-user-container">
      <div className="create-user-header">
        <div />
        <h1>Create Club Account</h1>
        <img
          id="logo_img"
          src={image}
          alt=""
          style={{ maxHeight: "120px", maxWidth: "120px" }}
        />
      </div>
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="sections-wrapper">
          <UserForm
            formData={formData}
            setFormData={setFormData}
            user={null}
            errorBorders={errorBorders}
            setImage={setImage}
          />
        </div>
        <Button className="saveBtn" onClick={handleSubmit}>
          Create
        </Button>
      </form>
    </div>
  );
};

export default UserEdit;
